export const ADMIN_LEVEL_URLS = {
  GET_ADMIN_LEVELS: '/admin-levels',
  GET_SINGLE_ADMIN_LEVEL: '/admin-levels/:id',
  GET_ADMIN_LEVELS_MAPPINGS: '/admin-levels/mappings',
  CREATE_ADMIN_LEVEL: '/admin-levels',
  UPDATE_ADMIN_LEVEL: '/admin-levels/:id',
  DELETE_ADMIN_LEVEL: '/admin-levels/:id'
};
